import { CobaltLoaderLinear } from '@cae/cobalt-react/components/loader-linear';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './LandingCarouselCard.module.css';
import { LandingCarouselCardProps } from './LandingCarouselCard.types';

const LandingCarouselCard = React.memo(
  ({
    tab,
    isActive,
    isAutoPlaying,
    progress,
    onClick,
  }: Readonly<LandingCarouselCardProps>): React.ReactElement => {
    const { t } = useTranslation();
    const [isClicked, setIsClicked] = React.useState(false);

    const handleClick = React.useCallback((): void => {
      setIsClicked(true);
      onClick(tab.id);
    }, [onClick, tab.id]);

    React.useEffect(() => {
      if (!isActive) {
        setIsClicked(false);
      } else if (!isAutoPlaying) {
        setIsClicked(true);
      }
    }, [isActive, isAutoPlaying]);

    return (
      <button
        role="tab"
        type="button"
        aria-selected={isActive}
        aria-controls={`carousel-panel-${tab.id}`}
        className={[
          styles.landingCarouselCard,
          isClicked ? styles.landingCarouselCardActive : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={handleClick}
        data-testid={`carousel-tab-${tab.id}`}
      >
        <img
          src={tab.iconSrc}
          alt=""
          aria-hidden="true"
          className={styles.landingCarouselCardIcon}
        />
        <span className={styles.landingCarouselCardText}>
          <span className={`${styles.landingCarouselCardLabel} heading-02`}>
            {t(tab.labelKey)}
          </span>
          <span className={`${styles.landingCarouselCardSublabel} body-02`}>
            {t(tab.sublabelKey)}
          </span>
          </span>

        {isActive && isAutoPlaying && (
          <CobaltLoaderLinear
            mode="determinate"
            value={progress}
            state="loading"
            size="small"
            className={styles.landingCarouselCardProgressBar}
            data-testid={`carousel-progress-${tab.id}`}
          />
        )}
      </button>
    );
  }
);

LandingCarouselCard.displayName = 'LandingCarouselCard';

export { LandingCarouselCard };
